module.exports = __webpack_public_path__ + "static/gcrew-logo-4adf0c197c6d0aa51b97c3c5222216dd.png";